import React, { FC, ReactElement, useRef, useEffect } from "react";
import { observer } from "mobx-react";
import Container from "ui/Container/Container";
import Search from "common/Header/components/Search/Search";
import Profile from "common/Header/components/Main/components/Profile/Profile";
import Favorites from "common/Header/components/Main/components/Favorites/Favorites";
import Cart from "common/Header/components/Main/components/Cart/Cart";
import StickyCatalog from "common/Header/components/StickyCatalog/StickyCatalog";
import mainStyles from "common/Header/components/Main/Main.module.scss";
import { useStore } from "store";
import { cn } from "helpers/style";
import { useMountTransition } from "helpers/hooks";
import styles from "./Sticky.module.scss";

const Sticky: FC = (): ReactElement => {
  const { header, search, user } = useStore();
  const searchRef = useRef(null);
  const transitionIn = useMountTransition(header.stickyHeader, 200);

  useEffect(() => {
    const onwheel = () => {
      search.toggleShowSuggestions(false);
    };
    document.body.addEventListener("wheel", onwheel);
    return () => {
      document.body.removeEventListener("wheel", onwheel);
    };
  }, []);

  if (!header.stickyHeader && !transitionIn) return null;

  return (
    <div
      className={cn([
        styles.sticky,
        header.stickyHeader ? styles.stickyShow : styles.stickyHide,
        user.isEmployeeMode && styles.stickyEmployee,
      ])}
    >
      <Container>
        <div className={styles.stickyContainer}>
          <StickyCatalog
            onOpen={() => search.toggleShowSuggestions(false)}
            employeeMode={user.isEmployeeMode}
          />
          <Search
            ref={searchRef}
            className={styles.stickySearch}
            buttonClassName={styles.stickySearchButton}
            classNameOverlay={styles.stickyOverlay}
            sticky
          />
          <div className={mainStyles.mainUser}>
            <Profile sticky />
            <Favorites />
            <Cart />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default observer(Sticky);
